import { render, staticRenderFns } from "./Materials.vue?vue&type=template&id=56b60cab&"
import script from "./Materials.vue?vue&type=script&lang=js&"
export * from "./Materials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Simply\\Simply.Web.Website\\Static\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56b60cab')) {
      api.createRecord('56b60cab', component.options)
    } else {
      api.reload('56b60cab', component.options)
    }
    module.hot.accept("./Materials.vue?vue&type=template&id=56b60cab&", function () {
      api.rerender('56b60cab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Js/Components/DataView/Aggregation/Materials.vue"
export default component.exports